import {useDocksStateContext} from 'modules/reports/contexts/docks/DocksContext'
import useCore from 'modules/reports/hooks/core'
import React from 'react'
import useStyles from './ReportsDockContainer.styles'

type Props = {
  className?: React.ReactNode
  children: React.ReactNode
}

function ReportsDockContainer(props: Props) {
  const {className, children} = props
  const classes = useStyles()
  const {p} = useCore('reports', 'components', 'DockContainer')
  const {dock} = useDocksStateContext()
  const DockC = dock ? dock.component : null

  return (
    <div className={`${classes.root} ${className || ''}`} data-testid={p()}>
      {children}

      {dock && DockC && (
        <div className={classes.dock}>
          <DockC {...dock.props} />
        </div>
      )}
    </div>
  )
}

export default ReportsDockContainer
